import React, { FC, useEffect, useState } from 'react';
import { checkForWorkspaceFeatures, checkForActivation } from 'wisestep-api';

import { useWorkspaceContext } from '../../context';
import { useSKUModalStore } from '../skuModal/SKUModalStore';

interface IActivityCard {
  children: React.ReactNode;
  feature: string;
}

const ActivateFeature: FC<IActivityCard> = ({ children, feature }: IActivityCard) => {
  const setModal = useSKUModalStore((state) => state.setModal);
  const workspaceContext = useWorkspaceContext();
  const workspaceFeatures = workspaceContext.workspacePlan;
  const [childNodes, setChildNodes] = useState<React.ReactNode[]>([]);

  useEffect(() => {
    async function validateFeature() {
      const displayIsOn = await checkForWorkspaceFeatures(workspaceFeatures, feature);
      let nodes: any = [];
      if (displayIsOn) {
        const canActivateFeature = checkForActivation(workspaceFeatures, feature) ?? false;
        if (!canActivateFeature) {
          nodes = React.Children.map(children, (child) => {
            if (React.isValidElement(child)) {
              if (child.props['onClick']) {
                const props = {
                  onClick: () => setModal({ type: 'link' }),
                };
                const newProps = { ...child.props, ...props };
                return React.cloneElement(child, newProps);
              } else {
                return <></>;
              }
            }
            return child;
          });
        } else {
          nodes = children;
        }
        setChildNodes(nodes ?? []);
      }
    }
    validateFeature();
  }, [feature, children, workspaceFeatures, setModal, workspaceContext.id]);

  return <>{childNodes}</>;
};

export default ActivateFeature;
